import { render, staticRenderFns } from "./PrintInvoice.vue?vue&type=template&id=3883d306"
import script from "./PrintInvoice.vue?vue&type=script&lang=ts"
export * from "./PrintInvoice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports